/** Избранное через ручки из `contract.ts`; mock — только при `VITE_FAVORITES_MOCK=true`. */
import type { ApiClient } from '../client'
import type { FavoriteDto } from './contract'
import type { FavoritesBackend } from './mocks/store'

export function createHttpFavorites(api: ApiClient): FavoritesBackend {
  return {
    list: async () => (await api.get<{ items?: FavoriteDto[] }>('/me/favorites')).items ?? [],
    add: async (productId) => {
      await api.put<unknown>(`/me/favorites/${productId}`)
    },
    remove: async (productId) => {
      await api.del<unknown>(`/me/favorites/${productId}`)
    },
    merge: async (productIds) => {
      await api.post<unknown>('/me/favorites/merge', { product_ids: productIds })
    },
  }
}
